import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { DEMO_MODE } from "./lib/demoMode";

async function prepare() {
  // MSW demo worker is opt-in. Production (.env.production) sets REACT_APP_DEMO_MODE=false
  // so this branch is compile-time dead on app.brxs.ca.
  if (DEMO_MODE) {
    const { worker } = await import('./demo/browser')
    await worker.start({ onUnhandledRequest: 'bypass' })
  } else if ('serviceWorker' in navigator) {
    window.addEventListener('load', function () {
      navigator.serviceWorker.register('/sw.js')
    })
  }
}

function mountApp() {
  const root = ReactDOM.createRoot(document.getElementById("root"))
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}

prepare().then(mountApp).catch((err) => {
  console.error('MSW setup failed, mounting app without mock service worker:', err)
  mountApp()
})
